import React, { useCallback, useEffect, useState } from 'react';
import { Box, Grid, Theme, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import SettingsIcon from '@mui/icons-material/Settings';
import { Dropdown1 } from '../../shared/components/utils/Dropdown1';
import { PairItem } from './components/PairItem';
import { Loading } from '../../shared/components/Loading';
import { SortOrder, Strategy, useStrategiesLazyQuery } from '../../shared/types/generated';
import { ButtonDefault } from '../../shared/components/ButtonDefault';
import { createPairDialogStoreAction } from './pair-actions';
import { CreatePairDialog } from './components/CreatePairDialog';
import { DeletePairDialog } from './components/DeletePairDialog';

const useStyles = makeStyles<Theme>(() =>
  createStyles({
    cleanButton: {
      background: 'none!important',
      border: 'none!important',
      cursor: 'pointer',
      color: '#000!important',
      height: 30,
      width: 30,
      margin: '0 0',
    },
    eventsNone: {
      pointerEvents: 'none',
    },
  }),
);

const optionTime = ['1M', '1S', '1H'];
const optionPriceStrem = ['Real Time', 'Time lapse', 'Historic'];


export const Pairs: React.FC = () => {
  const [openFilterMenu, setOpenFilterMenu] = useState(false);
  const [actualTimeOption, setActualTimeOption] = useState(0);
  const [actualOptionPriceStrem, setActualOptionPriceStrem] = useState(0);
  const classes = useStyles();
  const [callStrategies, { data, loading }] = useStrategiesLazyQuery({
    onCompleted: () => {
    },
  });

  const callback = useCallback(() => {
    callStrategies({ variables: { take: 100, orderBy: [{ status: SortOrder.Asc}] } });
  }, [callStrategies]);

  useEffect(() => {
    callback();
  }, [callback]);

  const strategies = (data?.strategies?.items || []) as Strategy[];

  return (
    <Box
      border={'1px solid #F1F1F1'}
      borderRadius={'10px'}
      style={{ background: 'white' }}
    >
      <Grid my={'5px'} px={'10px'} container spacing={1}>
        <Grid xs={12} item>
          <Box textAlign='end'>
            <ButtonDefault color='primary' onClick={() => createPairDialogStoreAction({ open: true })}>Add
              Pair</ButtonDefault>
          </Box>
        </Grid>
        <Grid xs={12} item>
          <Grid
            container
            py={'5px'}
            style={{ background: '#F8F8F8' }}
            borderBottom={'1px solid #F0F0F0'}
            px={'15px'}
          >
            <Grid display={'flex'} alignItems={'center'} item xs={3}>
              <Typography fontWeight={600}>Pair</Typography>
              <Box
                position={'relative'}
                display={'flex'}
                alignItems={'center'}
                width={40}
              >
                <button
                  onClick={() => setOpenFilterMenu(!openFilterMenu)}
                  className={classes.cleanButton}
                >
                  <SettingsIcon fontSize='small' />
                </button>
                {openFilterMenu ? (
                  <Box paddingBottom={'3px'} width={400}>
                    <Box display={'flex'} alignItems={'center'}>
                      <Typography width={140}>Time Interval</Typography>
                      <Box paddingLeft={1}>
                        <Dropdown1
                          options={optionTime}
                          selectedIndex={actualTimeOption}
                          setSelectedIndex={setActualTimeOption}
                        />
                      </Box>
                      <Typography paddingLeft={1} width={150}>
                        Price Stream
                      </Typography>
                      <Box paddingLeft={1} width={200}>
                        <Dropdown1
                          options={optionPriceStrem}
                          selectedIndex={actualOptionPriceStrem}
                          setSelectedIndex={setActualOptionPriceStrem}
                        />
                      </Box>
                    </Box>
                  </Box>
                ) : null}
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Typography fontWeight={600} textAlign={'center'}>
                Last Price
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography fontWeight={600} textAlign={'center'}>
                Actions
              </Typography>
            </Grid>
          </Grid>
          {loading ? (
            <Loading height='350px' />
          ) : (
            strategies.map((strategy) => (
              <PairItem strategy={strategy} onSuccess={() => callback()} />
            ))
          )}
        </Grid>
      </Grid>
      <CreatePairDialog onSuccess={() => callback()} />
      <DeletePairDialog onSuccess={() => callback()} />
    </Box>
  );
};
